import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useDeleteUserBoardCardConfigsForUserMutation } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import * as Queries from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.dfc.new';
import { useSelectedPipelineIdByAccess } from '../hooks/useSelectedPipelineIdByAccess';
import { useAppId } from '../hooks/useAppId';
export const useResetCardSectionSettings = () => {
  const pipelineId = useSelectedPipelineIdByAccess();
  const objectTypeId = useObjectTypeId();
  const appId = useAppId();
  const [resetCardSectionSettings, {
    loading,
    error
  }] = useDeleteUserBoardCardConfigsForUserMutation({
    variables: {
      objectTypeId,
      pipelineId,
      appId
    },
    refetchQueries: [Queries.GET_USER_BOARD_CARD_CONFIG_QUERY],
    awaitRefetchQueries: true
  });
  return {
    resetCardSectionSettings,
    loading,
    error
  };
};